export enum StorageKey {
  USER_TYPE = 'userType',
  CULTURE = 'culture',
  TEMP_USER_TYPE = 'tempUserType',
  EMAIL = 'email',
  BASESITE = 'baseSite',
  CURRENCY = 'currency',
  CONFIRMATION_CART = 'confirmationCart',
  'CART_rentalGB' = 'cart_rentalGB',
  'CART_rentalSK' = 'cart_rentalSK',
  'CART_rentalPL' = 'cart_rentalPL',
  'CART_rentalNL' = 'cart_rentalNL',
  'CART_rentalLU' = 'cart_rentalLU',
  'CART_rentalIT' = 'cart_rentalIT',
  'CART_rentalHU' = 'cart_rentalHU',
  'CART_rentalDE' = 'cart_rentalDE',
  'CART_rentalCZ' = 'cart_rentalCZ',
  'CART_rentalCH' = 'cart_rentalCH',
  'CART_rentalBE' = 'cart_rentalBE',
  'CART_rentalAT' = 'cart_rentalAT',
}
